// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vC43","colBig":"styles_colBig__2R4pB","colSmall":"styles_colSmall__Dmz-I","shopifyNameWrapper":"styles_shopifyNameWrapper__Lxvba"};